const binding = { modules: {}, dataActions: {} };

    (binding.modules['sign-in'] = {
        c: () => require('@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'sign-in',
        p: 'account-management',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|themes|newsunshine-b2c|views|sign-in'] = {
                c: () => require('partner/themes/newsunshine-b2c/views/sign-in.view.tsx'),
                cn: '__local__-__local__-sign-in'
            };
viewDictionary['__local__|__local__|themes|newsunshine|views|sign-in'] = {
                c: () => require('partner/themes/newsunshine/views/sign-in.view.tsx'),
                cn: '__local__-__local__-sign-in'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-in|sign-in'] = {
                c: () => require('@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in.view.js'),
                cn: '@msdyn365-commerce-modules-account-management-sign-in'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|sign-in'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/sign-in.view.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-sign-in'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };